<template>
  <div class="second-step">
    <div class="left-step">
      <span class="left-title">2</span>
      <span class="left-line"></span>
    </div>
    <div class="right-step">
      <h4>第二步：确认个人信息</h4>
      <div class="second-content">
        <p>大学：{{content.studentUniversity}}</p>
        <p>学院：{{content.studentCollege}}</p>
        <p>专业：{{content.studentMajor}}</p>
        <p>学号：{{content.studentNo}}</p>
        <p>姓名：{{content.studentName}}</p>
      </div>
    </div>
    <el-button
    	type="success"
    	@click="submit"
    	class="btn-success"
    >确认绑定</el-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
export default {
  props: {
    content:Object
  },
  name: 'SecondStep',
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  methods: {
    submit() {
      const options = {
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded'},
        data:qs.stringify({openId: this.shengyaUser.openid,studentNo: this.content.studentNo}),
        url:'/cob/bindStudentByNo.do'
      }
      axios(options)
      .then( (res) => {
        res = res.data
        if (res.result.success) {
          this.$router.push('/')
        }
        else{
          this.$store.commit('showMessage', {
            message:res.result.message,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .second-step
    margin:0 0.3rem
    .left-step
      float:left
      .left-title
        color:#5cb85c
        width:22px
        heihgt:20px
        display:block
        text-align:center
        border:1px solid #5cb85c
        border-radius:50%
      .left-line
        width:1px
        height:150px
        display:block
        margin-left:12px
        background-color:#5cb85c
    .right-step
      float:left
      margin-left:5px
      width:90%
      h4
        margin-bottom:0.2rem
      .second-content
        background-color:#ffffff
        border:1px solid #BBBBBB
        padding:0.2rem
        p
          text-align:left
          margin-left:0.2rem
    .btn-success
      color:#ffffff
      width:100%
      margin:0.2rem 0
</style>
